import { Box, Stack } from "@mui/material";
import { ProtectionZoneForm as ProtectionZoneFormType } from "../../../types/forms/capture";
import { ProtectionZoneResponse } from "../../../types/model/protectionZone";
import ProtectionZoneForm from "./ProtectionZoneForm";

interface CaptureProtectionZoneProps {
  protectionZoneData?: ProtectionZoneResponse | null;
  canEdit: boolean;
  onCreate: (values: ProtectionZoneFormType) => Promise<void>;
  onUpdate: (protectionZoneId: number, values: ProtectionZoneFormType) => Promise<void>;
}

export default function CaptureProtectionZone({
  protectionZoneData,
  canEdit,
  onCreate,
  onUpdate
}: Readonly<CaptureProtectionZoneProps>) {
  const isExisting = !!protectionZoneData;

  return (
    <Stack spacing={2}>
      <Box>
        <ProtectionZoneForm
          protectionZoneData={protectionZoneData}
          canEdit={canEdit}
          onSubmit={async (values) => {
            if (isExisting && protectionZoneData?.id) {
              await onUpdate(protectionZoneData.id, values);
            } else {
              await onCreate(values);
            }
          }}
        />
      </Box>
    </Stack>
  );
}